module.exports = __webpack_public_path__ + "img/orange.088866ce.jpg";